import React from 'react';
import { useTranslation } from 'react-i18next';
import Hero from '../components/Home/Hero';
import WhyChooseUs from '../components/Home/WhyChooseUs';
import Sustainability from '../components/Home/Sustainability';
import Testimonials from '../components/Home/Testimonials';
import MostSellingWorkwear from '../components/Home/MostSellingWorkwear';
import TrustedLogos from '../components/Home/TrustedLogos';
import NewsletterCTA from '../components/Home/NewsletterCTA';
import WhatWeOffer from '../components/Home/WhatWeOffer';
import FamilyBusinessBuiltValues from '../components/Home/FamilyBusinessBuiltValues';

const Home = () => {
  useTranslation();
  // paint-page.webp
  return (
    <div>
      <Hero />
      <FamilyBusinessBuiltValues />
      <WhatWeOffer />
      <WhyChooseUs />
      <Sustainability />
      <Testimonials />
      <MostSellingWorkwear />
      <NewsletterCTA />
      <TrustedLogos />
    </div>
  );
};

export default Home;
